<template>
    <div v-title="'工业服务未来发展论坛'" class="service-box" v-if="details">
        <div class="video-main">
            <video-player  class="video-player vjs-custom-skin"
                ref="videoPlayer"
                :playsinline="true"
                :options="videoPlayerOptions"
                @play="onPlayerPlay($event)"
                @pause="onPlayerPause($event)"
                @ended="onPlayerEnded($event)"
                @waiting="onPlayerWaiting($event)"
                @playing="onPlayerPlaying($event)"
                @loadeddata="onPlayerLoadeddata($event)"
                @timeupdate="onPlayerTimeupdate($event)"
                @canplay="onPlayerCanplay($event)"
                @canplaythrough="onPlayerCanplaythrough($event)"
                @statechanged="playerStateChanged($event)"
                @ready="playerReadied"
            ></video-player>
        </div>
        <div class="tabs-main">
            <van-tabs 
                v-model="active" 
                animated 
                swipeable
            >
                <van-tab title="聊天">
                    <div class="tabs-content">
                        <div class="tabs-share">
                            <div>
                                <h4>锦 鲤 抽 奖</h4>
                                <p @click="onShowShare" v-if="!details.IsSubscribe">分享获取我的幸运号码<van-icon name="play" color="#F9F22D" /></p>
                                <p v-else>幸运号码：{{details.LotteryYards}}</p>
                            </div>
                        </div>
                        <div class="chat-box">
                            <div class="up-scroll" id="up">
                                <ul class="chat-list">
                                    <li v-for="(item,index) in chatArr" :key="index">
                                        <img v-show="item.isBpoMember" src="~@/assets/forum/vip.png" alt="VIP">
                                        <span>{{item.userName}}</span>：{{item.message}}
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div class="send-box">
                        <input type="text" ref="inputText" placeholder="参与讨论" v-model="text" @keyup.enter="sendButton">
                        <button @click="sendButton">发送</button>
                    </div>
                </van-tab>
                <van-tab title="互动">
                    <div class="tabs-content-two">
                        <div class="discuss-link" @click="openAPP">
                            <p>参与讨论，获取白皮书勋章和定制实体书</p>
                            <van-icon name="arrow" />
                        </div>
                        <div class="bbs-main">
                            <ul class="bbs-list">
                                <li class="bbs-item" v-for="(item,index) in forumList" :key="index" @click="openAppForum(item.Id)">
                                    <div>
                                        <h3>{{item.Title}}</h3>
                                        <div><van-icon name="good-job-o" />{{item.ThumbUpCount}}</div>
                                    </div>
                                    <p>{{item.ShortContent}}</p>
                                </li>
                            </ul>
                        </div>
                    </div>
                </van-tab>
                <van-tab title="证书">
                    <div class="tabs-content">
                        <div class="certificate-main">
                            <ul class="certificate-list">
                                <li class="certificate-item">
                                    <div>
                                        <h3>数字化工业服务工程师<br/>供配电低压类证书</h3>
                                    </div>
                                </li>
                                <li>
                                    <div>
                                        <h3>供配电<br/>中高压类</h3>
                                    </div>
                                </li>
                                <li>
                                    <div>
                                        <h3>自动化类</h3>
                                        <p>PLC可编程控制器</p>
                                    </div>
                                </li>
                                <li>
                                    <div>
                                        <h3>自动化类</h3>
                                        <p>数控机床系统</p>
                                    </div>
                                </li>
                                <li>
                                    <div>
                                        <h3>自动化类</h3>
                                        <p>人机交互</p>
                                    </div>
                                </li>
                                <li>
                                    <div>
                                        <h3>自动化类</h3>
                                        <p>DCS分布控制系统</p>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </van-tab>
                <van-tab title="友情赞助">
                    <div class="tabs-content">
                        <div class="friendlink-main">
                            <ul class="friendlink-list">
                                <li class="friendlink-link" v-for="(item,index) in sponsorList" :key="index" @click="linkSponsor(item.SponsorSiteUrl)">
                                    <img :src="item.LogoUrl" :alt="item.SponsorIntroduce">
                                </li>
                                <li class="friendlink-item" @click="$router.push({path: '/addFriendlink'})">
                                    <div>
                                        <h4>征集更多赞助商</h4>
                                        <span>点击联系>></span>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </van-tab>
            </van-tabs>
        </div>
        <div class="wx-mask" v-if="isShowWX" @click="isShowWX=false"></div>
    </div>
</template>
<script>
    import {
        mapState
    } from 'vuex'
    import { 
        GetForumSubscribeInfo,
        DoForumSubscribeCallBack,
        GetForumPostList,         //获取列表
        GetSponsorList,           //赞助商列表
        AddServiceForumStatistics,//添加访问数据
    } from "@/common/api.js";
    import {videoPlayer} from 'vue-video-player'
    import $ from "jquery"
    import bridge from '@/common/dsbridge.js';
    let u = navigator.userAgent;
    let ua = navigator.userAgent.toLowerCase();
    var connection;
    var int = null;
    export default {
        components:{
            videoPlayer,
        },
        data(){
            return {
                appUserInfo: null,              //app里的用户信息
                userid: 0,                 //app里的用户id 不带p
                companyId: 0,
                isWeb: true,                    //是否是浏览器 true 是 false 否
                isShowWX: false,


                video:'',         //具体视频
                fileType: 'mp4', // 资源的类型
                videoUrl: '',	// 资源的路径地址
                posterUrl: '',  //封面地址
                n: '',          //播放第几个
                isn: true,      //是否第一次播放

                active: 0,

                chatArr: [],
                text: '',

                details: null,
                forumList: [],      //速派论坛
                sponsorList: [],    //赞助商列表

            }
        },
        created() {
            this.isWeb=typeof(bridge.call('getUserInfo'))==='undefined'?true:false;
            this.getUserInfo();
        },
        computed: {
            ...mapState({
                userData: state => state.userData,
                createConfig: state => state.createConfig,
            }),
            videoPlayerOptions () {
                const videoPlayerOptions = {
                    // playbackRates: [0.75, 1.0, 1.25, 1.5,2.0], //播放速度
                    autoplay: true, // 是否自动播放。
                    // controls: true,
                    muted: false, // 是否静音播放，默认情况下将会消除任何音频。
                    loop: false, // 是否循环播放。
                    preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
                    language: 'zh-CN',
                    // aspectRatio: '3:1', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
                    fluid: true, // 是否流体从而按比例缩放以适应其容器。
                    // flash:{hls:{withCreadentials:false}},//可以播放rtmp视频
                    // html5:{hls:{withCreadentials:false}},//可以播放m3u8视频
                    sources: [
                    {
                        type: 'video/' + this.fileType,
                        src: this.videoUrl // 视频url地址
                        // src:require('../../assets/forum/11.mp4')
                    }],
                    poster: this.posterUrl, // 封面地址
                    width: '100%',
                    notSupportedMessage: '此视频暂无法播放...', // 当无法播放时允许覆盖Video.js，显示的默认信息。
                    controlBar: {
                        timeDivider: false,
                        durationDisplay: false,
                        remainingTimeDisplay: false,
                        fullscreenToggle: true,            //全屏按钮
                        currentTimeDisplay: false,
                        progressControl: false,
                    }
                }
                return videoPlayerOptions
            },
        },
        mounted(){
            var self = this
            bridge.register('notifyLoginSuccess', function () {
                self.getUserInfo();
            });
            bridge.register('shareSuccessBack', function () {
                self.shareSuccessBack()
            });
            this.getForumPostListFun();
            this.getSponsorListFun();
            this.addServiceForumStatisticsFun();
            // 生成随机游客的账号也是有区分本地环境和线上环境的
            let request = 'https://activityapi.insupai.com'
            // if(process.env.NODE_ENV == 'development') {
            //     request = `http://activityapi.gongkongbpo.qa`
            //     // request = `http://192.168.1.69:8002`
            // }else if(process.env.NODE_ENV == 'text'){
            //     request = `https://tactivityapi.insupai.com`
            // }else {
            //     request = `https://activityapi.insupai.com`
            // }
            connection = new signalR.HubConnectionBuilder().withUrl(`${request}/chatHub`).build();
            //加载前3条消息
            connection.on("GetTop3Msg", function (json) {
                self.chatArr = json
            });
            //接收到消息后
            connection.on("ReceiveMessage", function (json) {
                self.chatArr.push(json)
                var scrollHeight = $('.chat-list').prop("scrollHeight");
                $('#up').animate({scrollTop:scrollHeight},600)
            });
            //展示错误信息
            connection.on("ShowError", function (msg) {
                console.log("ShowError:" + msg);
            });

            this.start();
            //长时间会断开，断开后重新链接
            connection.onclose(() => {
                console.log('断开后重新链接')
                this.start();
            });
        },
        methods: {
            // 添加统计数据
            addServiceForumStatisticsFun(){
                let data = {}
                data.AppId = 2
                if(this.appUserInfo && !this.isWeb) {
                    data.UserCode = this.appUserInfo.userId || ''
                }else if(this.userData && this.isWeb){
                    data.UserCode = this.userData.UserCode || ''
                }
                AddServiceForumStatistics(data).then(res=>{
                    console.log('统计')
                })
            },
            getUserInfo(){
                let self = this
                let info = bridge.call('getUserInfo') || null;
                if(info) {
                    this.appUserInfo = JSON.parse(info).isLogin?JSON.parse(info):null;
                    if(this.appUserInfo) {
                        if (this.appUserInfo.userId.indexOf('p') === 0) {
                            this.userid = Number(this.appUserInfo.userId.substr(1));
                        }else if(this.appUserInfo.userId.indexOf('e') === 0){
                            this.companyId = Number(this.appUserInfo.userId.substr(1));
                        }
                    }
                }
                // setTimeout(function(){
                    self.getConfigDetails()
                // },500)
            },
            getConfigDetails(){
                let data = {}
                if(this.appUserInfo && !this.isWeb) {
                    if(this.userid) {
                        data.UserId = this.userid
                    }else{
                        data.CompanyId = this.companyId
                    }
                }else if(this.userData && this.isWeb) {
                    if(this.userData && this.userData.UserId){
                        data.UserId=this.userData.UserId;
                    }else if(this.userData && this.userData.CompanyId){
                        data.CompanyId=this.userData.CompanyId;
                    }
                }
                GetForumSubscribeInfo(data).then(res=>{
                    if(res.Result != 1) {
                        return this.$toast('请重新获取');
                    }
                    console.log(res.Data)
                    this.details = res.Data
                    this.$nextTick(()=> {
                        if(this.details.LiveStep == 1) {
                            this.n = this.details.PreheatingVideoCurrentSortNum - 1
                            this.videoUrl = this.details.PreheatingVideoList[this.n].VideoUrl
                        }else if(this.details.LiveStep == 2){
                            this.videoUrl = this.details.LiveStreamingVideoUrl
                        }
                        this.$refs.videoPlayer.player.src(this.videoUrl)
                        if(this.details.LiveStep == 1) {
                            int = setInterval(()=>{
                                setTimeout(()=>{
                                    let myDate = Date.parse(new Date())
                                    let begin = new Date(this.details.LiveStartTime).getTime()
                                    let end = new Date(this.details.LiveEndTime).getTime()
                                    console.log(1)
                                    if(begin < myDate && myDate < end) {
                                        console.log(2)
                                        clearInterval(int)
                                        this.getConfigDetails();
                                    }
                                },0)
                            },60000)
                        }
                    })
                })
            },
            onShowShare(){
                if(!/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)) {
                    return this.$toast('请在移动端查看！');
                }
                if(!this.appUserInfo && !this.isWeb) {
                    return bridge.call('launchLogin');
                }
                if(!this.userData && this.isWeb) {
                    return this.$router.push({ path: "/login/personLogin",query:{link:'forum'} });
                }
                if(this.appUserInfo) {
                    bridge.call('userShare',`{
                        "shareUrl":"${window.location.origin}/#/forum?link=forum",
                        "shareTitle":"预约有礼-工业服务未来发展论坛",
                        "shareDesc":"暨《中国工业服务产业发展白皮书》发布会",
                        "shareIcon":"https://gk-manager.oss-cn-zhangjiakou.aliyuncs.com/icon/share.png",
                        "isShareWxSmallProgram":false
                    }`);
                }else{
                    this.shareSuccessBack()
                    // this.showShare=true
                }
            },
            shareSuccessBack(){
                if(this.details.IsSubscribe){ 
                    return
                }
                let data = {}
                if(this.appUserInfo && !this.isWeb) {
                    if(this.userid) {
                        data.UserId = this.userid
                    }else{
                        data.CompanyId = this.companyId
                    }
                }else if(this.userData && this.isWeb) {
                    if(this.userData && this.userData.UserId){
                        data.UserId=this.userData.UserId;
                    }else if(this.userData && this.userData.CompanyId){
                        data.CompanyId=this.userData.CompanyId;
                    }
                }
                DoForumSubscribeCallBack(data).then(res=>{
                    if(res.Result != 1) {
                        return this.$toast('请重新获取');
                    }
                    this.$toast('预约成功！');
                    this.details = res.Data
                })
            },

            // 获取速派论坛
            getForumPostListFun(){
                let data = {}
                if(this.appUserInfo && !this.isWeb) {
                    data.UserCode = this.appUserInfo.userId || ''
                }else if(this.userData && this.isWeb){
                    data.UserCode = this.userData.UserCode || ''

                }
                GetForumPostList(data).then(res=>{
                    this.forumList = res.Data.ForumPostModelList || []
                })
            },
            // 赞助商列表
            getSponsorListFun(){
                let data = {}
                data.PageNum = 0;
                data.PageSize = 1;
                GetSponsorList(data).then(res=>{
                    this.sponsorList = res.Data.SponsorList || []
                })
            },
            // 赞助商跳转
            linkSponsor(url){
                window.open(url)
            },






            // 连接
            start(){
                let self = this
                try {
                    //链接
                    connection.start().then(function () {
                        // console.log('connection.start');
                        //上线
                        // self.userData.UserCode
                        connection.invoke("OnLine", self.userData.UserCode).catch(function (err) {
                            return console.error(err.toString());
                        });
                    });
                }
                catch (err) {
                    setTimeout(function () { this.start() }, 5000);
                    return console.error(err);
                }
            },
            //发送消息
            sendButton(event){
                if(!this.userData){
                    this.$router.push({ path: "/login/personLogin",query:{link:'forum'} });
                    return;
                }
                if(!this.text) {
                    this.$toast('内容不可为空！')
                    this.$refs.inputText.focus()
                    return
                }
                connection.invoke("SendMessage", this.text).then(res=>{
                    this.text = ''
                    this.$refs.inputText.focus()
                }).catch(function (err) {
                    this.$toast('发送失败，请重试！')
                    this.start();
                    return
                });
                event.preventDefault();
            },

            openAPP() {
                if (ua.match(/MicroMessenger/i) == 'micromessenger') {
                    this.isShowWX = true;
                    return;
                }

                if (u.indexOf('Android') > -1 || u.indexOf('Linux') > -1) {
                    console.log('安卓');
                    window.location.href =
                        `gongkongsupai://com.gongkong.supai?launchType=18`;
                    clearTimeout(this.timer);
                    this.timer = setTimeout(() => {
                        window.location.href = 'https://wx.insupai.com/download/download.html';
                        clearTimeout(this.timer);
                    }, 3000);
                } else if (u.indexOf('iPhone') > -1) {
                    console.log('苹果');
                    window.location.href =
                        `gongkongsupai://param?launchType=18`;
                    clearTimeout(this.timer);
                    this.timer = setTimeout(() => {
                        window.location.href = 'https://wx.insupai.com/download/download.html';
                        clearTimeout(this.timer);
                    }, 3000);
                }
            },
            openAppForum(id){
                if (ua.match(/MicroMessenger/i) == 'micromessenger') {
                    this.isShowWX = true;
                    return;
                }

                if (u.indexOf('Android') > -1 || u.indexOf('Linux') > -1) {
                    console.log('安卓');
                    window.location.href =
                        `gongkongsupai://com.gongkong.supai?launchType=16&forumId=${id}`;
                    clearTimeout(this.timer);
                    this.timer = setTimeout(() => {
                        window.location.href = 'https://wx.insupai.com/download/download.html';
                        clearTimeout(this.timer);
                    }, 3000);
                } else if (u.indexOf('iPhone') > -1) {
                    console.log('苹果');
                    window.location.href =
                        `gongkongsupai://param?launchType=16&forumId=${id}`;
                    clearTimeout(this.timer);
                    this.timer = setTimeout(() => {
                        window.location.href = 'https://wx.insupai.com/download/download.html';
                        clearTimeout(this.timer);
                    }, 3000);
                }
            },








             // 播放回调
            onPlayerPlay(player) {
                // console.log('player play!', player)
            },
            // 暂停回调
            onPlayerPause(player) {
                // console.log('player pause!', player)
            },
            // 视频播完回调
            onPlayerEnded(player) {
                if(this.details.LiveStep == 1) {
                    let myDate = Date.parse(new Date())
                    let begin = new Date(this.details.LiveStartTime).getTime()
                    let end = new Date(this.details.LiveEndTime).getTime()
                    if(begin < myDate && myDate < end) {
                        return this.getConfigDetails();
                    }
                    if(this.n >= this.details.PreheatingVideoList.length-1) {
                        this.n = 0
                    }else{
                        this.n ++
                    }
                    this.videoUrl = this.details.PreheatingVideoList[this.n].VideoUrl
                    this.$refs.videoPlayer.player.src(this.videoUrl)
                }else if(this.details.LiveStep == 2) {
                    return this.getConfigDetails();
                }
                // console.log('视频播完回调',player)
            },
            // DOM元素上的readyState更改导致播放停止
            onPlayerWaiting($event) {
                //console.log(player)
            },
            // 已开始播放回调
            onPlayerPlaying($event) {
                if(this.details.LiveStep == 1) {
                    let myDate = Date.parse(new Date())
                    let begin = new Date(this.details.LiveStartTime).getTime()
                    let end = new Date(this.details.LiveEndTime).getTime()
                    if(begin < myDate && myDate < end) {
                        return this.getConfigDetails();
                    }
                }
                // console.log('已开始播放回调',$event)
            },
            // 当播放器在当前播放位置下载数据时触发
            onPlayerLoadeddata($event) {
                
                // console.log('当播放器在当前播放位置下载数据时触发',$event)
            },
            // 当前播放位置发生变化时触发。
            onPlayerTimeupdate(player) {
                // console.log('当前播放位置发生变化时触发。',$event)
            },
            //媒体的readyState为HAVE_FUTURE_DATA或更高
            onPlayerCanplay(player) {
                
            // console.log('player Canplay!', player)
            },
            //媒体的readyState为HAVE_ENOUGH_DATA或更高。这意味着可以在不缓冲的情况下播放整个媒体文件。
            onPlayerCanplaythrough(player) {
                
            // console.log('player Canplaythrough!', player)
            },
            //播放状态改变回调
            playerStateChanged(playerCurrentState) {
                // let mydata = Date.parse(new Date())
                // console.log(mydata)
            //console.log('player current update state', playerCurrentState)
            },
            //将侦听器绑定到组件的就绪状态。与事件监听器的不同之处在于，如果ready事件已经发生，它将立即触发该函数。。
            playerReadied(player) {
                this.$nextTick(()=>{
                    if(this.isn) {
                        if(this.details.LiveStep == 1) {
                            player.currentTime(this.details.PreheatingVideoCurrentSecond)
                        }else if(this.details.LiveStep == 2){
                            player.currentTime(this.details.LiveCurrentSecond)
                        }
                        this.isn = false
                    }
                    const myPlayer = this.$refs.videoPlayer.player
                    myPlayer.play()
                })
            },
        },
    }
</script>
<style lang="scss">
@import '~@/style/_base.scss';
.service-box {
    background: #fff;
    .video-main {
        width: 100%;
        height: px2rem(422px);
        // position: sticky;
        // top: 0;
        // z-index: 2;
        .video-js .vjs-big-play-button .vjs-icon-placeholder:before {
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);
            font-size: px2rem(64px);
            width: auto;
            height: auto;
        }
        .vjs-custom-skin > .video-js .vjs-big-play-button {
            width: px2rem(120px) !important;
            height: px2rem(120px) !important;
            border-radius: 50%;
            margin-left: 0 !important;
            margin-top: 0 !important;
            transform: translate(-50%, -50%);
        }
        video {
            display: block;
            height: px2rem(422px);
            background:#0F0F0F;
        }
        .vjs-custom-skin > .video-js {
            width: 930px;
            height: px2rem(422px);
        }
        .vjs-fluid {
            padding-top: 0;
            width: 930px;
            height: px2rem(422px);
        }
        .video-js .vjs-tech {
            width: 100% !important;
            height: 100% !important;
        }
        .vjs-fullscreen-control {
            position: absolute;
            right: 0;
            top: 0;
        }
    }
    .tabs-main {
        // background: #F9F22D;
        .default-tabs .van-tab__text {
            font-size: px2rem(30px);
            color: #666;
        }
        .van-tab--active .van-tab__text {
            font-size: px2rem(36px);
            color: #333;
            font-weight: bold;
            font-family: 'Source Han Sans CN';
        }
        .van-tabs__line {
            height: px2rem(8px);
            border-radius: px2rem(4px);
            background: #F75959;
        }
        .tabs-content {
            padding-top: px2rem(36px);
            padding-left: px2rem(28px);
            padding-right: px2rem(28px);
            min-height: calc(100vh - 6.8rem);
            // background: #f9f9f9;
            .tabs-share {
                width: 100%;
                height: px2rem(140px);
                background: #f9f9f9;
                background-image: url("~@/assets/forum/lucky-bg.png");
                background-repeat: no-repeat;
                background-size: cover;
                border-radius: px2rem(10px);
                display: flex;
                align-items: center;
                padding-left: px2rem(38px);
                margin-bottom: px2rem(30px);
                h4 {
                    font-size: px2rem(40px);
                    font-weight: bold;
                    color: #fff;
                }
                p {
                    font-size: px2rem(28px);
                    color: #F9F22D;
                    display: flex;
                    align-items: center;
                }
            }
            .chat-box {
                width: 100%;
                height: calc(100vh - 11rem);
                // background: red;
                position: relative;
                .up-scroll {
                    height: 100%;
                    margin-right: px2rem(16px);
                    margin-right: px2rem(-16px);
                    overflow-x: hidden;
                    overflow-y: scroll;
                    .chat-list {
                        overflow: hidden;
                        li {
                            color: #333;
                            font-size: px2rem(28px);
                            line-height: px2rem(40px);
                            // padding-bottom: 10px;
                            word-break: break-all;
                            span {
                                font-size: px2rem(28px);
                                font-weight: bold;
                            }
                            img {
                                margin-right: px2rem(6px);
                            }
                        }
                    }
                    &::-webkit-scrollbar {
                        width: 0px;
                        height: 0;
                        display:none;
                    }
                }
            }
            // 证书
            .certificate-main {
                ul {
                    display: flex;
                    justify-content: space-between;
                    flex-wrap: wrap;
                    li {
                        width: px2rem(333px);
                        height: px2rem(204px);
                        margin-bottom: px2rem(30px);
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        text-align: center;
                        background-image: url('~@/assets/forum/card-bg.png');
                        background-repeat: no-repeat;
                        background-size: cover;
                        border-radius: px2rem(20px);
                        overflow: hidden;
                        h3 {
                            font-size: px2rem(30px);
                            color: #333;
                            font-weight: 500;
                            line-height: px2rem(50px);
                        }
                        p {
                            font-size: px2rem(28px);
                            color: #666;
                            line-height: px2rem(48px);
                        }
                    }
                }
            }
            // 友情赞助
            .friendlink-main {
                .friendlink-list {
                    display: flex;
                    flex-wrap: wrap;
                    justify-content: space-between;
                    li {
                        width: px2rem(219px);
                        height: px2rem(205px);
                        border: 1px solid #e9e9e9;
                        border-radius: px2rem(10px);
                        margin-bottom: px2rem(20px);
                        img {
                            display: block;
                            max-width: 100%;
                            height: 100%;
                        }
                    }
                    .friendlink-item {
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        text-align: center;
                        h4 {
                            font-size: px2rem(28px);
                            color: #333;
                            font-weight: 500;
                        }
                        span {
                            color: #f75959;
                            font-size: px2rem(20px);
                            font-weight: bold;
                        }
                    }
                    &:after {
                        content: "";
                        width: px2rem(219px);
                    }
                }
            }
                
        }
        // 互动
        .tabs-content-two {
            padding-top: px2rem(36px);
            min-height: calc(100vh - 6.8rem);
            .discuss-link {
                padding-left: px2rem(28px);
                padding-right: px2rem(28px);
                height: px2rem(84px);
                background: rgba(247, 89, 89, .3);
                display: flex;
                justify-content: space-between;
                align-items: center;
                color: #f75959;
                font-size: px2rem(28px);
                line-height: px2rem(28px);
            }
            .bbs-main {
                .bbs-list {
                    background: #f9f9f9;
                    li {
                        background: #fff;
                        padding-left: px2rem(28px);
                        padding-right: px2rem(28px);
                        padding-top: px2rem(10px);
                        padding-bottom: px2rem(20px);
                        margin-bottom: px2rem(20px);
                        > div {
                            display: flex;
                            align-items: center;
                            justify-content: space-between;
                            height: px2rem(78px);
                            h3 {
                                width: 80%;
                                color: #333;
                                font-size: px2rem(34px);
                                font-weight: bold;
                                overflow:hidden;
                                text-overflow:ellipsis;
                                white-space:nowrap
                            }
                            > div {
                                display: inline-flex;
                                align-items: center;
                                font-size: px2rem(28px);
                                color: #999;
                                .van-icon-good-job-o {
                                    color: #999;
                                    font-size: px2rem(50px);
                                    margin-right: px2rem(4px);
                                }
                            }
                        }
                        p {
                            font-size: px2rem(28px);
                            color: #333;
                            line-height: px2rem(44px);
                            overflow: hidden;
                            text-overflow: ellipsis;
                            display: -webkit-box;
                            -webkit-line-clamp: 3;
                            -webkit-box-orient: vertical;
                        }
                    }
                }
            }
        }
        .send-box {
            position: fixed;
            bottom: 0;
            left: 0;
            z-index: 2;
            height: px2rem(100px);
            width: 100%;
            padding-left: px2rem(28px);
            padding-right: px2rem(28px);
            display: flex;
            align-items: center;
            justify-content: space-between;
            box-shadow: 0px -5px 20px 0px rgba(34, 23, 20, 0.1);
            input {
                width: px2rem(614px);
                height: px2rem(56px);
                padding: 0 px2rem(42px);
                background: #F1F1F1;
                border-radius: 28px;
                font-size: px2rem(24px);
                color: #333;
            }
            button {
                font-size: px2rem(26px);
                font-weight: 400;
                color: #999;
                background: none;
            }
        }
    }
}

.wx-mask{
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    z-index: 999;
    @include bg('~static/image/pointer.png');
    background-size: cover;
    background-position: top center;
}
</style>